import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import AdminPage from '../layouts/AdminPage';
import services from '../services';

const PrivateRoutes = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            services.storage.get('isAuthenticated')
            ? <AdminPage> <Component {...props} />  </AdminPage>
            : <Redirect to={{ pathname: '/', state: { from: props.location }}} />
        )} />
    )
}

export default PrivateRoutes;